<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-28 18:59:43
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-30 12:26:50
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\src\index\index.vue
-->
<template>
  <div class="containerPage" v-cloak>
    <div class="headerCom">
      <div class="set-public-flex">
        <publicBreadCrumb :breadList="breadList" />
        <div class="heard-right">
          <!-- <span v-if="$route.query.userId" style="display:inline-block;margin-right:20px">用户ID：{{$route.query.userId}}</span> -->
          <el-button type="primary" v-if="isConsult=='true'" size="mini" @click="backTo(1)">返回客服咨询</el-button>
          <!-- 1：患者存在疗管房间及 -->
          <el-button type="primary" v-if='backCaseFlag' size="mini" @click="backTo(2)">返回疗程管理</el-button>
          <el-button type="primary" v-if="backListFlag" size="mini" @click="backToPatientList">返回列表</el-button>
        </div>
      </div>
    </div>

    <section>
      <div class="chat-content">
        <div class="chat-header">
          <UserHeader :headerData="userData"></UserHeader>
        </div>
        <div class="patient-first-tab">
          <Tabs v-if="tabFlag" @headerTabs="headerNavTabsHandel" :tabsDataList="UserTabs" :activeName="activeName">
          </Tabs>
        </div>
        <!-- 动态组件-->
        <component :is="componentsName" :userData="userData" :patientId="patientId" @isEdit="tabsIsChange"
          ref="componentRef" mode="out-in">
        </component>
      </div>
    </section>
  </div>
</template>

<script>
import { apiPatientPage, apiGetPatientArchvies } from "../../api";
import UserHeader from "../../components/UserHeader";
import Tabs from "@/views/treatment/components/Tabs";
import HeaderSearch from "../../components/HeaderSearch";
import ChatUserList from "@/views/treatment/components/ChatUserList";
import ImList from "@/views/treatment/common";
import { decisionExecutedRecordList } from "@/views/treatment/api/crossApi.js";
import local from "@/utils/local.js";

export default {
  mixins: [ImList],
  name: "patientManage",
  data() {
    return {
      isConsult: local.get("isConsult"),
      backListFlag: false,
      backCaseFlag: false,
      breadList: [{ name: "病人管理" }, { name: "病人详情" }],
      routerName: "",
      fromDataValue: {},
      archivesEventId: "",
      UserTabs: [
        {
          name: "首页",
          id: "1",
          iconNumber: "",
          componentName: "PatientHome"
        },
        {
          name: "诊疗计划",
          id: "2",
          iconNumber: "",
          componentName: "TreatmentPlan"
        },
        {
          name: "任务列表",
          id: "3",
          iconNumber: "",
          componentName: "TaskList"
        },
        {
          name: "不良事件",
          id: "4",
          iconNumber: "",
          componentName: "UserEvent"
        },
        {
          name: "信息监测",
          id: "5",
          iconNumber: "",
          componentName: "InfoMonitor"
        },
        {
          name: "用药记录",
          id: "6",
          iconNumber: "",
          componentName: "MedicationAdministrationRecords"
        }
      ],
      userDataList: [], //聊天列表
      userData: {}, //选中的用户所有信息
      componentsName: local.get("tabActive") || "PatientHome",
      isEditFlag: true,
      beforeLeave: function() {
        return true;
      },

      patientId: "", //当前查看用户的患者id
      empty: false,
      setintervalTime: null,
      tabIndex: 0,
      tabFlag: false,
      activeName: local.get("tabActive") || "PatientHome"
    };
  },
  components: {
    Tabs,
    UserHeader,
    PatientHome: () => import("../../components/PatientHome"), //异步组件
    TreatmentPlan: () => import("../../components/TreatmentPlan/index"),
    TaskList: () => import("../../components/TaskList/index"),
    UserEvent: () => import("../../components/UserEvent/index"),
    InfoMonitor: () => import("../../components/InfoMonitor/index"),
    MedicationAdministrationRecords: () =>
      import("../../components/MedicationAdministrationRecords"),
    HeaderSearch,
    ChatUserList
  },
  watch: {
    "$store.state.menuData": {
      handler(arr) {
        this.buttonShow(arr);
      },
      deep: true
    }
  },
  created() {
    this.buttonShow(this.$store.state.menuData);
    this.$socket.emit("currentMenu", "patient", data => {});
    this.$socket.emit("setStatus", "", data => {});
    let { patientId } = this.$route.query;
    if (this.$route.query && this.$route.query.tabIndex) {
      this.tabIndex = this.$route.query.tabIndex;
      this.activeName = this.UserTabs[this.tabIndex].componentName;
      this.componentsName = this.UserTabs[this.tabIndex].componentName;
      if (this.$route.query.archivesEventId) {
        this.archivesEventId = this.$route.query.archivesEventId;
      }
    }
    // if(this.$route.query && this.$route.query.routerName){
    //   this.routerName = this.$route.query.routerName
    // }
    this.patientId = patientId;
    this.tabFlag = true;
    this.initData(patientId);
  },
  beforeRouteLeave(to, from, next) {
    local.remove("tabActiveItem"); // 清除local中保存的数据
    local.remove("tabActive");
    next();
  },
  methods: {
    buttonShow(arr) {
      if (arr.length) {
        arr.map(item => {
          if (item.component == "/treatment" && item.children) {
            this.backCaseFlag = item.children.some(child => {
              return child.component == "/case";
            });
          }
          if (item.component == "/patientmanage" && item.children) {
            this.backListFlag = item.children.some(child => {
              return child.component == "/patientmanage";
            });
          }
        });
      }
    },
    // 返回患者列表
    backToPatientList() {
      let patientListCon = local.get("patientListCon");
      this.$router.push({
        name: "Patientmanage",
        params: {
          condition: JSON.parse(patientListCon)
        }
      });
    },
    /**
     * @description: 接收孙组件发来的消息,修改后重新callback
     * @param {*}
     * @return {*}
     */
    tabsIsChange() {
      this.initData(this.patientId);
    },

    /**
     * @description: 患者信息的点击触发事件
     * @param {*}
     * @return {*}
     */
    headerNavTabsHandel(event) {
      this.tabIndex = event.id - 1;
      this.activeName = this.UserTabs[this.tabIndex].componentName;
      local.set("tabActive", this.activeName);
      local.set("tabActiveItem", "");
      this.componentsName = event.componentName;
    },
    /**
     * @description: 过滤用户状态
     * @param {*}
     * @return {*}
     */
    filterTypeHandel(value) {
      switch (value) {
        case 1:
          return "未申请";
        case 2:
          return "已跟进";
        case 3:
          return "评估中";
        case 4:
          return "待确认";
        case 5:
          return "服务中";
        case 6:
          return "已拒绝";
        case 8:
          return "已退款";
        case 12:
          return "已到期";
        default:
          return "未知状态";
      }
    },
    /**
     * @description: 筛选条件重置
     * @param {*}
     * @return {*}
     */
    resetHandel(event) {
      this.fromDataValue = event;
    },
    /**
     * @description: chatUserList子组件传递过来的属性 点击好友列表进入问诊房间 进入问诊房间
     * @param {*}
     * @return {*}
     */
    activeHande(event) {
      event.unreadCount = 0;
    },
    /**
     * @description: 拿患者ID得到右侧所有信息
     * @param {* patientId}
     * @return {*}
     */
    initData(patientId) {
      apiGetPatientArchvies(patientId).then(res => {
        if (res.code == 0) {
          this.userData = res.data;
          this.userData.newArchivesEventId = this.archivesEventId;
        }
      });
    },
    backTo(val) {
      let pageName = "IntoTheCase";
      if (val == 1) {
        pageName = "customerRoom";
      }
      this.$router.push({
        name: pageName,
        params: {
          keyword: this.userData.patientName
        }
      });
    }
  },
  sockets: {
    connect(data) {},
    leftMenuNumber(datas) {
      // if (datas.constructor === Object) {
      if (typeof datas === "string") {
        this.$websocket.dispatch("getLeftMenuNumber", JSON.parse(datas));
        datas = JSON.parse(datas);
      } else {
        this.$websocket.dispatch("getLeftMenuNumber", datas);
      }
      // }
    },
    // 右侧数据
    rightData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.setIntervalTime);
  }
};
</script>
<style scoped lang="less">
@import "./index.less";
/deep/.el-tabs__nav-wrap::after {
  background: transparent;
}
</style>
<style lang="less">
.patient-first-tab {
  margin-bottom: 2px;
  .el-tabs__item {
    width: 120px;
    height: 47px;
    background: #ffffff;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    line-height: 47px;
    margin-right: 2px;
  }
  .el-tabs__item.is-active {
    background: #1a7bfc;
    color: #ffffff;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
}
</style>